import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// import { roomCreate, roomJoin, clearError } from "../../../../redux/actions/roomAction";
import { roomJoin, clearError } from "../../../redux/actions/roomAction";
import { tokenValidation } from "../../../redux/actions/userAction";
import "./roomRegister.css";

const RoomPassword = props => {
	const dispatch = useDispatch();
	const history = useHistory();
	const userState = useSelector(state => state.user); // { isLoading, validToken, id, username, email, err }
	const roomState = useSelector(state => state.room); // { isLoading, _id, roomName, messages: { [ _id, username, message ] }, err: "Missing field" || "Room already exist" ||  "Room doesn't exist" || "Invalid password"

	const [roomInfo, setRoomInfo] = useState({ roomName: props.rooomName, password: "" });
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorMessageVisible, setIsErrorMessageVisible] = useState(false);

	useEffect(() => {
		if (roomState.err) dispatch(clearError());
		setRoomInfo({ roomInfo, roomName: props.rooomName });
	}, []);

	useEffect(() => {
		if (roomState.err) {
			switch (roomState.err) {
				case "Missing field":
					setErrorMessage(`Warning: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;

				case "Room already exist": // Error for room create
				case "Room doesn't exist": // Error for room join
					setRoomInfo({ roomName: props.rooomName, password: "" });
					setErrorMessage(`Invalid input: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;

				case "Invalid password": // Error for room join
					setRoomInfo({ roomName: props.rooomName, password: "" });
					setErrorMessage(`Invalid input: ${roomState.err}`);
					setIsErrorMessageVisible(true);
					break;

				case "":
					setIsErrorMessageVisible(false);
					break;

				default:
					setIsErrorMessageVisible(false);
					break;
			}
		}
	}, [roomState.err]);

	const [registerBtnClick, setRegisterBtnClicked] = useState(false); // Indicates whether register button is clicked or not
	// After Receiving the token verification, redirect to login if token is invalid and if valid dispatch roomJoin
	useEffect(() => {
		if (!userState.isLoading && registerBtnClick) {
			if (userState.validToken) {
				dispatch(roomJoin(props.rooomName, roomInfo.password));
				setRegisterBtnClicked(false);
			} else history.push("/login");
		}
	}, [userState]);

	// Wait for the chat data to load before proceeding to board page
	useEffect(() => {
		if (roomState._id) history.push(`/board/${roomState._id}`);
	}, [roomState._id]);

	return (
		<React.Fragment>
			<div className="roomRegister-watch">
				<div className={props.isRoomVisible ? "join-room-visible" : "join-room-hidden"}>
					<div
						className="bg-clicker"
						onClick={() => {
							props.setRoomVisibility(false);
							setIsErrorMessageVisible(false);
						}}
					></div>
					<div className="room101">
						<h1 className="title">Board</h1>
						<input
							type="text"
							name="roomName"
							placeholder="Board Name"
							className={props.rooomName ? "input-empty input-highlight" : "input-empty"}
							value={props.rooomName}
							disabled
						/>

						<h1 className="title">Password</h1>
						<input
							type="password"
							name="password"
							placeholder="Password"
							className={roomInfo.password ? "input-empty input-highlight" : "input-empty"}
							value={roomInfo.password}
							onChange={e => {
								setRoomInfo({ ...roomInfo, [e.target.name]: e.target.value });
								if (errorMessage) {
									setIsErrorMessageVisible(false);
									dispatch(clearError());
								}
							}}
						/>

						<input
							type="submit"
							value="JOIN"
							className="board-submit"
							onSubmit={() => console.log("submit alert!!!!")}
							onClick={() => {
								dispatch(tokenValidation()); // validating the token
								setRegisterBtnClicked(true);
								console.log(roomInfo);
							}}
						/>
						<span className={isErrorMessageVisible ? "warning-enable error-msg" : "warning-disable error-msg"}>
							{errorMessage}
						</span>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default RoomPassword;
